import { render, staticRenderFns } from "./page-step-layout.vue?vue&type=template&id=185d9a83&scoped=true"
import script from "./page-step-layout.vue?vue&type=script&lang=ts"
export * from "./page-step-layout.vue?vue&type=script&lang=ts"
import style0 from "./page-step-layout.vue?vue&type=style&index=0&id=185d9a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d9a83",
  null
  
)

export default component.exports